'use strict'
const getCurrentUser = require('../security/browser/CurrentUser.js').getCurrentUser

const modal = new (require('../helpers/modal'))
const ajax = require('../helpers/ajax')
const forms = new (require('../helpers/forms'))

module.exports = class _baseWidget {

	constructor(editor, doc, config, data, block4render, widget, title) {
		this._promise = new Promise(fulfill => {
			this._fulfill = fulfill
		})

		this._editor = editor
		this._doc = editor.doc
		this._id = doc.querySelector('[mbry-page-id]').getAttribute('mbry-page-id')
		this._idBlock = widget.parentNode.getAttribute('mbry-block')
		this._idBlockNum = widget.parentNode.getAttribute('mbry-block-id')
		this._idWidget = widget.getAttribute('mbry-widget')
		this._config = config
		this._data = data
		this._block4render = block4render
		this._widget = widget
		this._title = title
		this._widgetClone = widget.cloneNode(true)
		this._blockNextNode = widget.parentNode.nextElementSibling

		if (this._block4render && !this._block4render.options) {
			this._block4render.options = {}
		}

		this._buildElem()
		this._setTitle()
		this.onInit()

	}

	_activateScripts() {
		const scripts = this._widget.querySelectorAll('script')
		scripts.forEach(script => {
			let ins = this._doc.createElement('script')
			if (script.src) { ins.src = script.src }
			ins.type = 'text/javascript'
			ins.innerHTML = script.innerText
			script.parentNode.insertBefore(ins, script)
			script.remove()
		})
	}

	_render(data) {

		const search = this._doc.defaultView.location.search
		// renders widget. not block (parent)
		ajax({
			method: 'PUT',
			url: '/article/-/' + this._id + '/' + this._idWidget + search,
			dataType: 'application/json',
			data: {
				block_id: this._idBlock,
				data: data || this._block4render,
			}
		}).then(html => {

			const toremove = []
			this._widget.childNodes.forEach(item => {
				if (item.className === 'edit-tools-edit') { return }
				toremove.push(item)
			})
			toremove.forEach(node => { node.remove() })
			let temp = document.createElement('div')
			temp.innerHTML = html
			temp.childNodes.forEach(node => {
				this._widget.appendChild(node.cloneNode(true))
			})
			this._activateScripts()

			this._buildElem()
			this._setTitle()
			this.onInit()

		})
	}

	_getBlockData(article, id) {
		let data
		id = parseInt(id)
		article.data.forEach((block) => {
			if (block.meta.pageBlockId === id) {
				data = block
			}
		})
		return data
	}

	onInit() {}

	_buildElem() {

		this._container = document.createElement('div')
		this._container.className = 'editor'
		this._container.innerHTML = `
			<div class="buttons"></div>
			<div class="title"></div>
			<div class="tools"></div>
		`
		this._elemButtons = this._container.querySelector('.buttons')
		this._elemTitle = this._container.querySelector('.title')
		this._elemTools = this._container.querySelector('.tools')

		this._toolsButtons().forEach(node => {
			this._elemTools.appendChild(node)
		})

		let container = document.querySelector('#main')
		container.innerHTML = ''
		container.appendChild(this._container)
	}

	_setTitle() {
		this._elemTitle.innerHTML =
			'<span class="name">' + this._title[0] + '</span>' +
			'blok ' + this._idBlockNum +
			' / widget ' + (parseInt(this._title[1]) + 1)
	}

	_toolsButtons() {

		let space = document.createElement('span')
		space.className = 'btn-space'

		let settings = document.createElement('button')
		settings.innerHTML = '<i class="material-icons">settings</i>'
		settings.onclick = () => this._formSettings()

		let done = document.createElement('button')
		done.innerHTML = '<i class="material-icons">done</i>'
		done.onclick = () => {
			this._saveArticle(done)
			this._close()
		}

		let clear = document.createElement('button')
		clear.innerHTML = '<i class="material-icons">clear</i>'
		clear.onclick = () => {
			this._originalContent()
			this._close()
		}
		clear.disabled = this._renderOnStart

		let del = document.createElement('button')
		del.innerHTML = '<i class="material-icons">delete</i>'
		del.onclick = () => {
			const p = window.confirm('Naozaj chcete zmazať tento widget?')
			if (p) {
				del.disabled = true
				this._deleteWidget()
				this._saveArticle(del)
				this._close()
			}
		}

		let sortUp = document.createElement('button')
		sortUp.innerHTML = '<i class="material-icons">arrow_upward</i>'
		sortUp.onclick = () => {
			this._editor.move(-1, sortUp, sortDown)
		}

		let sortDown = document.createElement('button')
		sortDown.innerHTML = '<i class="material-icons">arrow_downward</i>'
		sortDown.onclick = () => {
			this._editor.move(+1, sortUp, sortDown)
		}

		this._editor.move(0, sortUp, sortDown)

		let allowedBlocks = [];

		if (getCurrentUser().hasPermission(_CONF_INSTANCE_ + ':portal-editor:change-article-block-reorder')) {
			allowedBlocks.push(sortUp)
			allowedBlocks.push(sortDown)
		}

		allowedBlocks.push(space.cloneNode())

		if (getCurrentUser().hasPermission(_CONF_INSTANCE_ + ':portal-editor:change-article-block-settings')) {
			allowedBlocks.push(settings)
		}

		if (getCurrentUser().hasPermission(_CONF_INSTANCE_ + ':portal-editor:change-article-block-delete')) {
			allowedBlocks.push(del)
		}

		allowedBlocks.push(space.cloneNode())
		allowedBlocks.push(done)
		allowedBlocks.push(clear)

		return this._idBlock === 'menu-zosr' ? [
			done, clear
		] : allowedBlocks
	}


	_deleteWidget() {
		if (typeof this._onDelete === 'function') {
			this._onDelete()
		}
	}

	_close() {
		document.querySelector('#main .editor').innerHTML = ''
		modal.hide()
		this._widget.classList.remove('active')
		this._widget.parentNode.classList.remove('active')
		this._doc.body.classList.remove('editing')
		this._fulfill()
		if (typeof this._onClose === 'function') { this._onClose() }
	}

	_originalContent() {
		this._widget
			.querySelectorAll(':scope > :not(.edit-tools-edit)')
			.forEach(item => {
				item.remove()
			})
		this._widgetClone
			.querySelectorAll(':scope > :not(.edit-tools-edit)')
			.forEach(node => {
				this._widget.appendChild(node)
			})
		this._widget.parentNode.parentNode
			.insertBefore(this._widget.parentNode, this._blockNextNode)

		if (typeof this._originalData === 'function') {
			this._originalData()
		}

		this._activateScripts()

	}

	_saveArticle(btn) {
		// from editor
		if (typeof this._onSave === 'function') {
			this._onSave(btn)
		}
		// extended by widget
		if (typeof this.onSave === 'function') {
			this.onSave(btn)
		}
		// extended by widget
		if (typeof this.onDestroy === 'function') {
			this.onDestroy()
		}
	}


	_formSettings() {

		let block = document.createElement('div')
		block.className = 'form-block reserve-space'
		let div = document.createElement('div')
		div.className = 'form-code'

		let input = document.createElement('textarea')
		input.className = 'textcode'
		input.value = JSON.stringify(this._block4render.options, null, 4)
		input.onkeydown = event => {
			if (event.keyCode === 9) {
				let v = input.value
				let s = input.selectionStart
				let e = input.selectionEnd
				input.value = v.substring(0, s) + '    ' + v.substring(e)
				input.selectionStart = input.selectionEnd = s + 4
				return false
			}
		}
		div.appendChild(input)

		block.appendChild(div)

		let button = document.createElement('button')
		button.className = 'btn btn-primary'
		button.innerHTML = 'Odoslať'
		button.onclick = () => {
			try {
				this._block4render.options = JSON.parse(input.value)
				modal.hide()
			} catch(err) {
				alert(err)
			}
		}
		block.appendChild(forms.actions(button))

		let formtitle = 'Rozšírené nastavenia (JSON)'
		modal.show(formtitle, block).then(() => { input.focus() })

	}

}



//////////////////
// WEBPACK FOOTER
// ./src/widgets/base.edit.js
// module id = 1
// module chunks = 0